module.exports = __webpack_public_path__ + "img/collatz.fcc45616.png";